import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    image: {
      width: '200px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
